export default "__VITE_ASSET__8RIWioGZ__"